import { publicURL } from '../../../helpers/environment';

export const tdlr = {
  agencyCode: '452',
  name: 'Texas Department of Licensing and Regulation',
  shortName: 'Licensing and Regulation',
  slug: 'tdlr',
  logo: publicURL('agency-logos/tdlr.png')
};
